import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Drawer, Portal } from '@mui/material';
import AiChatPanel from 'app/pages/loanApplication/tabs/aiChat/components/AiChatPanel';

import { setIsPanelOpenAction } from 'store/aiChat/actions';
import { selectAiChatIsPanelOpen } from 'store/aiChat/selectors';

import { AiAssistantTestId } from '../../AiAssistant.constants';

import { AI_ASSISTANT_DRAWER_MODAL_PROPS } from './AiAssistantDrawer.constants';
import { drawerPaperStyles, drawerRootStyles } from './AiAssistantDrawer.styles';

const paperProps = { sx: drawerPaperStyles };

const AiAssistantDrawer = () => {
  const dispatch = useDispatch();

  const isPanelOpen = useSelector(selectAiChatIsPanelOpen);

  const onClose = useCallback(() => {
    dispatch(setIsPanelOpenAction(false));
  }, [dispatch]);

  return (
    <Portal>
      <Drawer
        ModalProps={AI_ASSISTANT_DRAWER_MODAL_PROPS}
        PaperProps={paperProps}
        anchor="right"
        data-testid={AiAssistantTestId.DRAWER}
        open={isPanelOpen}
        sx={drawerRootStyles}
        variant="persistent"
        onClose={onClose}
      >
        <AiChatPanel />
      </Drawer>
    </Portal>
  );
};

export default memo(AiAssistantDrawer);
